import { AbstractPmsApiService } from './abstract.service';
import { BaseRate } from '../models';

/**
 * @class BaseRatePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BaseRate>}
 */
export class BaseRatePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/accommodation-type/:accommodationTypeId/base-rate(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BaseRate}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BaseRate(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @param {PropertyAccommodationType} accommodationType
     * @returns {Promise.<PaginationCollection<BaseRate>>}
     */
    get(params = {}, property = null, accommodationType = null) {

        const url = this.url({
            propertyId: property ? property.id : 0,
            accommodationTypeId: accommodationType ? accommodationType.id : 0
        });

        const ignoreLB = params.hasOwnProperty('searchValue');

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BaseRate} baseRate
     * @param {Property} property
     * @param {PropertyAccommodationType} accommodationType
     * @returns {Promise.<BaseRate>}
     */
    create(baseRate, property, accommodationType) {

        const url = this.url({
            propertyId: property.id,
            accommodationTypeId: accommodationType.id
        });

        return this.http
            .post(url, baseRate.toObjectExcept('property', 'accommodationType'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BaseRate} baseRate
     * @returns {Promise.<BaseRate>}
     */
    update(baseRate) {

        const url = this.url({
            propertyId: baseRate.accommodation_type.property.id,
            accommodationTypeId: baseRate.accommodation_type.id,
            id: baseRate.id
        });

        return this.http
            .put(url, baseRate.toObjectExcept('property', 'accommodationType'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BaseRate} baseRate
     * @returns {Promise.<BaseRate>}
     */
    updateNewInterval(baseRate) {

        const url = this.url({
            propertyId: baseRate.accommodation_type.property.id,
            accommodationTypeId: baseRate.accommodation_type.id,
            id: baseRate.old_id
        }) + '/update-new-interval';

        return this.http
            .put(url, baseRate.toObjectExcept('property', 'accommodationType'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BaseRate} baseRate
     * @returns {Promise.<boolean>}
     */
    delete(baseRate) {

        const url = this.url({
            propertyId: baseRate.accommodation_type.property.id,
            accommodationTypeId: baseRate.accommodation_type.id,
            id: baseRate.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    copy(destination, source) {

        const url = this.url({
            propertyId: destination.property.id,
            accommodationTypeId: destination.id,
        });

        return this.http
            .post(url + '/copy', {copy_from: source.id}, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    createForDate(baseRate, property, accommodationType) {

        const url = this.url({
            propertyId: property.id,
            accommodationTypeId: accommodationType.id
        }) + '/base-rate-date';

        return this.http
            .post(url, baseRate.toObjectExcept('property', 'accommodationType'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/base-rate.service.js